"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Dropdown_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Dropdown"));
var react_1 = require("react");
var Item_1 = __importDefault(require("./Item/Item"));
var genIcon_1 = __importDefault(require("../../../utils/genIcon"));
/**
 * For items that require hidable subitems or mixed content in the `<VerticalMenu/>` should be contained within a `<VerticalMenu.SubMenu/>` component. It is important to note that SubMenu's cannot be put in another SubMenu.
 * @child ./Item/Item.tsx
 */
var SubMenu = /** @class */ (function (_super) {
    __extends(SubMenu, _super);
    function SubMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubMenu.prototype.render = function () {
        var _a = this.props, text = _a.text, icon = _a.icon, iconRoot = _a.iconRoot, rest = __rest(_a, ["text", "icon", "iconRoot"]);
        return (React.createElement(Dropdown_1.default, __assign({}, rest, { item: true, simple: true, direction: "right", trigger: this.renderTrigger(), className: "vert-submenu" }),
            React.createElement(Dropdown_1.default.Menu, null, this.props.children)));
    };
    SubMenu.prototype.renderTrigger = function () {
        var _a = this.props, icon = _a.icon, iconRoot = _a.iconRoot;
        if (!this.props.icon) {
            return React.createElement("span", { className: "content-wrap" }, this.props.text);
        }
        else {
            return (React.createElement(React.Fragment, null,
                icon && genIcon_1.default(icon, { root: iconRoot, className: 'item-icon', size: 'small' }),
                React.createElement("span", { className: "content-wrap" }, this.props.text)));
        }
    };
    SubMenu.defaultProps = {
        iconRoot: 'common'
    };
    SubMenu.Item = Item_1.default;
    return SubMenu;
}(react_1.Component));
exports.default = SubMenu;
